'use strict';

class ItemTemplatesController {
    /* @ngInject */
    constructor(
        ItemTemplatesService,
        $scope,
        $q
    ) {
        Object.assign(this, {
            ItemTemplatesService,
            $scope,
            $q
        });

        this.query = {
            include: [],
            where: {},
            limit: 25,
            page: 1,
            order: 'name DESC',
            deleted: true
        };

        this.getItemTemplates();

        this.onPagination = () => {
            this.getItemTemplates();
        };
    }

    getItemTemplates() {
        let qOpts = JSON.parse(JSON.stringify(this.query));

        if (this.whereName) {
            let id = parseInt(this.whereName, 10);
            if (isNaN(id)) {
                Object.assign(qOpts.where, {
                    name : {
                        ilike: `%${this.whereName}%`
                    }
                });
            } else {
                Object.assign(qOpts.where, {
                    id: id
                });
            }
        }

        let queryReady = this.ItemTemplatesService
            .getModels(qOpts)
            .then(itemTemplates => {
                this.itemTemplates = itemTemplates;
            });
        let countReady = this.ItemTemplatesService
            .getCount(qOpts)
            .then(result => {
                this.itemTemplatesCount = result.count;
            });
        this.promise = this.$q.all([queryReady, countReady]);
        return this.promise;
    }

}

export default ItemTemplatesController;
